/* Pinzelli : carrousel « en cercle » (coverflow) pour la section Vidéos UGC.
   Sur la page : la vidéo du centre est mise en avant, les voisines de biais et en transparence, défilement auto.
   Navigation sur la page : glisser gauche/droite (la vidéo suit le doigt), pavé tactile horizontal, flèches, points.
   Le glissement vertical reste réservé au défilement de la page.
   Au clic sur la vidéo du centre : visionneuse plein écran avec le même effet en cercle, toujours sans son,
   passage à la vidéo suivante à la fin de chaque vidéo. Navigation : glisser gauche/droite OU haut/bas
   (façon Reels), molette / pavé tactile, flèches du clavier, Échap pour fermer.
   Réglages : section « Pz · Style de la page » › Carrousel des vidéos (window.pzCover = { on, delay, op }). */
(function () {
  var cfg = window.pzCover || {};
  if (cfg.on === false) return;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var sideOp = cfg.op == null ? 0.55 : +cfg.op;
  var ease = 'transform .8s cubic-bezier(.2,.7,.2,1),opacity .8s ease,filter .8s ease';
  var css = '.pzcf{position:relative;overflow:hidden;padding:6px 0 4px}' +
    '.pzcf .ugc__track{position:relative!important;display:block!important;overflow:visible!important;transform:none!important;scroll-snap-type:none!important;margin:0 auto!important;gap:0!important;touch-action:pan-y}' +
    '.pzcf .ugc__item{position:absolute!important;top:0;left:50%;width:min(58%,280px)!important;min-width:0!important;max-width:none!important;flex:none!important;margin:0!important;transition:' + ease + ';will-change:transform,opacity}' +
    '.pzcf.is-drag .ugc__item{transition:none!important}' +
    '@media(min-width:900px){.pzcf .ugc__item{width:min(28%,300px)!important}}' +
    '.pzcf .ugc__item[data-o]:not([data-o="0"]){filter:saturate(.85) brightness(.97)}' +
    '.pzcf .ugc__nav{z-index:6}' +
    '.pzcf-dots{display:flex;justify-content:center;gap:8px;margin-top:18px}' +
    '.pzcf-dots button{width:7px;height:7px;border-radius:99px;background:rgba(17,17,17,.22);border:0;padding:0;cursor:pointer;transition:width .35s ease,background .35s ease}' +
    '.pzcf-dots button.is-on{width:22px;background:#111}' +
    /* Visionneuse */
    '.pzcv{position:fixed;inset:0;z-index:2147483000;background:rgba(10,10,12,.86);-webkit-backdrop-filter:blur(14px);backdrop-filter:blur(14px);display:flex;flex-direction:column;align-items:center;justify-content:center;opacity:0;transition:opacity .35s ease;overflow:hidden;touch-action:none;overscroll-behavior:contain}' +
    '.pzcv.is-open{opacity:1}' +
    '.pzcv__stage{position:relative;width:100%;height:min(78vh,760px)}' +
    '.pzcv__item{position:absolute;top:0;left:50%;height:100%;aspect-ratio:9/16;max-width:78vw;border-radius:22px;overflow:hidden;background:#000;transition:' + ease + ';will-change:transform,opacity;cursor:pointer;box-shadow:0 30px 80px -30px rgba(0,0,0,.6)}' +
    '.pzcv__item video{width:100%;height:100%;object-fit:cover;display:block}' +
    '.pzcv__item:not([data-o="0"]){filter:brightness(.7) saturate(.85)}' +
    '.pzcv__close,.pzcv__nav{position:absolute;z-index:5;width:44px;height:44px;border-radius:50%;border:0;background:rgba(255,255,255,.14);color:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer;-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px)}' +
    '.pzcv__close{top:max(16px,env(safe-area-inset-top));right:16px}' +
    '.pzcv__nav{top:50%;transform:translateY(-50%)}.pzcv__nav--prev{left:16px}.pzcv__nav--next{right:16px}' +
    '@media(max-width:699px){.pzcv__nav{display:none}}' +
    '.pzcv__hint{margin-top:12px;font:600 12px/1 Manrope,system-ui,sans-serif;color:rgba(255,255,255,.75);display:flex;align-items:center;gap:6px;transition:opacity .5s ease}' +
    '.pzcv__hint svg{animation:pzcvUp 1.4s ease-in-out infinite}' +
    '@keyframes pzcvUp{0%,100%{transform:translateY(3px)}50%{transform:translateY(-3px)}}' +
    '@media(min-width:700px){.pzcv__hint{display:none}}' +
    '.pzcv .pzcf-dots{margin-top:16px}.pzcv .pzcf-dots button{background:rgba(255,255,255,.35)}.pzcv .pzcf-dots button.is-on{background:#fff}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  /* o peut être fractionnaire pendant qu'on glisse au doigt. */
  function place(el, o, far) {
    var a = Math.abs(o), x = o * (far || 64), r = o * -24;
    var s = a <= 1 ? 1 - 0.2 * a : Math.max(0.62, 0.8 - 0.18 * (a - 1));
    var op = a <= 1 ? 1 - (1 - sideOp) * a : Math.max(0, sideOp * (2 - a));
    el.dataset.o = Math.round(o);
    el.style.transform = 'translateX(calc(-50% + ' + x + '%)) perspective(1000px) rotateY(' + r + 'deg) scale(' + s + ')';
    el.style.opacity = op;
    el.style.zIndex = a < 0.5 ? 3 : (a < 1.5 ? 2 : 1);
    el.style.pointerEvents = a <= 1.2 ? 'auto' : 'none';
    el.setAttribute('aria-hidden', a < 0.5 ? 'false' : 'true');
    return Math.round(a);
  }
  function offset(k, i, n) { var o = ((k - i) % n + n) % n; if (o > n / 2) o -= n; return o; }
  /* Toujours sans son. */
  function play(v) { if (!v) return; v.muted = true; v.defaultMuted = true; v.volume = 0; if (v.preload === 'none') v.preload = 'auto'; var p = v.play && v.play(); if (p && p.catch) p.catch(function () {}); }
  function srcOf(item) { var v = item.querySelector('video'); if (!v) return null; var so = v.querySelector('source'); return { src: (so && so.src) || v.currentSrc || v.src, poster: v.poster || '' }; }

  /* ---------- Visionneuse plein écran ---------- */
  var viewer = null;
  function openViewer(list, start) {
    if (viewer) return;
    var n = list.length, i = start, t0 = null, lock = 0, wheelAcc = 0, moved = false;
    var root = document.createElement('div'); root.className = 'pzcv'; root.setAttribute('role', 'dialog'); root.setAttribute('aria-modal', 'true');
    root.innerHTML = '<button type="button" class="pzcv__close" aria-label="Fermer"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<button type="button" class="pzcv__nav pzcv__nav--prev" aria-label="Vidéo précédente"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 4L7 12L15 20"/></svg></button>' +
      '<button type="button" class="pzcv__nav pzcv__nav--next" aria-label="Vidéo suivante"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 4L17 12L9 20"/></svg></button>' +
      '<div class="pzcv__stage"></div><div class="pzcf-dots"></div>' +
      '<p class="pzcv__hint"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5M6 11l6-6 6 6"/></svg>Glisse pour la vidéo suivante</p>';
    var stage = root.querySelector('.pzcv__stage'), dots = root.querySelector('.pzcf-dots'), hint = root.querySelector('.pzcv__hint'), items = [];
    list.forEach(function (d, k) {
      var it = document.createElement('div'); it.className = 'pzcv__item';
      it.innerHTML = '<video playsinline muted preload="' + (Math.abs(offset(k, start, n)) <= 1 ? 'auto' : 'none') + '" poster="' + d.poster + '"><source src="' + d.src + '" type="video/mp4"></video>';
      stage.appendChild(it); items.push(it);
      var v = it.querySelector('video'); v.muted = true;
      v.addEventListener('volumechange', function () { if (!v.muted) v.muted = true; });
      v.addEventListener('ended', function () { if (k === i) go(i + 1); });
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Vidéo ' + (k + 1));
      b.addEventListener('click', function () { go(k); }); dots.appendChild(b);
    });
    function layout() {
      items.forEach(function (el, k) {
        var a = place(el, offset(k, i, n), 72), v = el.querySelector('video');
        if (a === 0) { v.currentTime = 0; play(v); } else { v.pause(); if (a === 1) v.preload = 'auto'; }
      });
      Array.prototype.forEach.call(dots.children, function (b, k) { b.classList.toggle('is-on', k === i); });
    }
    function go(k) { i = ((k % n) + n) % n; layout(); }
    function step(d) { var now = Date.now(); if (now < lock) return; lock = now + 550; go(i + d); if (hint) { hint.style.opacity = '0'; } }
    function close() {
      document.removeEventListener('keydown', onKey);
      root.classList.remove('is-open');
      items.forEach(function (el) { el.querySelector('video').pause(); });
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      setTimeout(function () { root.remove(); viewer = null; }, 350);
    }
    function onKey(e) {
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); step(1); }
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); step(-1); }
    }
    root.addEventListener('click', function (e) {
      if (moved) { moved = false; return; }
      if (e.target.closest('.pzcv__close')) return close();
      if (e.target.closest('.pzcv__nav--prev')) return step(-1);
      if (e.target.closest('.pzcv__nav--next')) return step(1);
      var it = e.target.closest('.pzcv__item');
      if (it) { var k = items.indexOf(it); if (k !== i) return go(k); var v2 = it.querySelector('video'); if (v2.paused) play(v2); else v2.pause(); return; }
      if (!e.target.closest('.pzcf-dots')) close();
    });
    root.addEventListener('touchstart', function (e) { t0 = { x: e.touches[0].clientX, y: e.touches[0].clientY }; moved = false; }, { passive: true });
    root.addEventListener('touchmove', function (e) { if (e.cancelable) e.preventDefault(); }, { passive: false });
    root.addEventListener('touchend', function (e) {
      if (!t0) return;
      var dx = e.changedTouches[0].clientX - t0.x, dy = e.changedTouches[0].clientY - t0.y; t0 = null;
      if (Math.max(Math.abs(dx), Math.abs(dy)) < 40) return;
      moved = true;
      if (Math.abs(dy) > Math.abs(dx)) step(dy < 0 ? 1 : -1); else step(dx < 0 ? 1 : -1);
    });
    root.addEventListener('wheel', function (e) {
      e.preventDefault();
      var d = Math.abs(e.deltaY) > Math.abs(e.deltaX) ? e.deltaY : e.deltaX;
      wheelAcc += d;
      if (Math.abs(wheelAcc) > 60) { step(wheelAcc > 0 ? 1 : -1); wheelAcc = 0; }
    }, { passive: false });
    document.addEventListener('keydown', onKey);
    document.body.appendChild(root);
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    viewer = root;
    layout();
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    setTimeout(function () { if (hint) hint.style.opacity = '0'; }, 4000);
  }

  /* ---------- Carrousel de la page ---------- */
  function init(car) {
    var track = car.querySelector('[data-ugc-track]');
    if (!track || car.dataset.pzcf) return;
    var items = Array.prototype.filter.call(track.children, function (el) { return el.classList.contains('ugc__item'); });
    var n = items.length;
    if (n < 3) return;
    car.dataset.pzcf = '1';
    car.classList.add('pzcf');
    var i = 0, timer = null, hover = false, visible = true, dragged = false, wheelAcc = 0, wheelLock = 0;
    var delay = Math.max(1.5, +cfg.delay || 3) * 1000;

    var dots = document.createElement('div'); dots.className = 'pzcf-dots';
    items.forEach(function (_, k) {
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Vidéo ' + (k + 1));
      b.addEventListener('click', function () { go(k); restart(); });
      dots.appendChild(b);
    });
    car.insertAdjacentElement('afterend', dots);

    function size() { var h = items[0].offsetHeight; if (h) track.style.height = h + 'px'; }
    function layout(shift) {
      shift = shift || 0;
      items.forEach(function (el, k) {
        var a = place(el, offset(k, i, n) + shift), v = el.querySelector('video');
        if (shift) return;
        if (a === 0) play(v); else if (v && v.pause) v.pause();
      });
      if (shift) return;
      Array.prototype.forEach.call(dots.children, function (b, k) { b.classList.toggle('is-on', k === i); });
      size();
    }
    function go(k) { i = ((k % n) + n) % n; layout(); }
    function tick() { if (!hover && visible && !viewer && !document.hidden) go(i + 1); }
    function restart() { if (reduce) return; clearInterval(timer); timer = setInterval(tick, delay); }

    track.addEventListener('click', function (e) {
      var item = e.target.closest('.ugc__item');
      if (!item) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (dragged) { dragged = false; return; }
      var k = items.indexOf(item);
      if (item.dataset.o !== '0') { go(k); restart(); return; }
      var list = items.map(srcOf).filter(Boolean);
      if (list.length === n) openViewer(list, k);
    }, true);
    car.addEventListener('click', function (e) {
      var nav = e.target.closest('[data-ugc-nav]');
      if (!nav) return;
      e.preventDefault(); e.stopImmediatePropagation();
      go(i + (nav.dataset.ugcNav === 'prev' ? -1 : 1)); restart();
    }, true);

    // Glisser au doigt : la vidéo suit le doigt à l'horizontale ; le vertical fait défiler la page.
    var t0 = null, dir = null, w = 1;
    track.addEventListener('touchstart', function (e) {
      t0 = { x: e.touches[0].clientX, y: e.touches[0].clientY }; dir = null; hover = true;
      w = (items[0].offsetWidth || 200) * 0.64;
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      if (!t0) return;
      var dx = e.touches[0].clientX - t0.x, dy = e.touches[0].clientY - t0.y;
      if (!dir && Math.max(Math.abs(dx), Math.abs(dy)) > 8) dir = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      if (dir !== 'x') return;
      if (e.cancelable) e.preventDefault();
      car.classList.add('is-drag');
      layout(Math.max(-1, Math.min(1, dx / w)));
    }, { passive: false });
    function endDrag(e) {
      hover = false;
      if (!t0) return;
      var dx = (e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientX : t0.x) - t0.x;
      car.classList.remove('is-drag');
      if (dir === 'x') {
        dragged = Math.abs(dx) > 10;
        if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1)); else layout();
        restart();
      }
      t0 = null; dir = null;
    }
    track.addEventListener('touchend', endDrag);
    track.addEventListener('touchcancel', endDrag);

    // Pavé tactile / molette horizontale sur ordinateur (le défilement vertical reste pour la page).
    car.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault();
      var now = Date.now(); if (now < wheelLock) return;
      wheelAcc += e.deltaX;
      if (Math.abs(wheelAcc) > 50) { go(i + (wheelAcc > 0 ? 1 : -1)); wheelAcc = 0; wheelLock = now + 600; restart(); }
    }, { passive: false });

    car.addEventListener('mouseenter', function () { hover = true; });
    car.addEventListener('mouseleave', function () { hover = false; });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }, { threshold: 0.25 }).observe(car);
    window.addEventListener('resize', size);
    items.forEach(function (el) { var v = el.querySelector('video'); if (v) { v.muted = true; v.addEventListener('loadedmetadata', size); } });
    layout(); setTimeout(size, 300); setTimeout(size, 1200);
    restart();
  }
  function run() { document.querySelectorAll('[id*="__ugc_videos"] .ugc__carousel').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();